import {
  CURRENCIES_DIRECT,
  TORFX,
  FCG,
  TORFX_OZ,
  CD,
  FOREMOST_CURRENCY_GROUP,
  CURRENCIES_DIRECT_SA,
  CDSA,
} from "../Constants/Constants";

export const getOrganizationName = (referringCompany: string) => {
  let OrgName: string;

  const ORGINIZATION_CODE_SELECTOR = {
    currenciesdirect: CURRENCIES_DIRECT,
    currenciesdirectsa: CURRENCIES_DIRECT_SA,
    torfx: TORFX,
    torfxoz: TORFX,
    fcg: FOREMOST_CURRENCY_GROUP,
  };
  OrgName = ORGINIZATION_CODE_SELECTOR[referringCompany];

  return OrgName;
};

export const getOrganizationCode = (referringCompany: string) => {
  let OrgCode: string;

  const ORGINIZATION_CODE_SELECTOR = {
    currenciesdirect: CD,
    currenciesdirectsa: CDSA,
    torfx: TORFX,
    torfxoz: TORFX_OZ,
    fcg: FCG,
  };
  OrgCode = ORGINIZATION_CODE_SELECTOR[referringCompany];

  return OrgCode;
};
